import { api } from '@/lib/api';
import type {
  GoChecklist,
  GoChecklistHistoryEntry,
  OverrideChecklistItemInput,
} from '../types/go-checklist.types';

export const goChecklistService = {
  async getCurrent(opportunityId: number): Promise<GoChecklist | null> {
    const { data } = await api.get<GoChecklist | null>(
      `/tm/opportunities/${opportunityId}/go-checklist`,
    );
    return data;
  },

  async getHistory(opportunityId: number): Promise<GoChecklistHistoryEntry[]> {
    const { data } = await api.get<GoChecklistHistoryEntry[]>(
      `/tm/opportunities/${opportunityId}/go-checklist/history`,
    );
    return data;
  },

  async recompute(opportunityId: number): Promise<{
    checklistId: number;
    verdict: string;
    itemCount: number;
  }> {
    const { data } = await api.post<{
      checklistId: number;
      verdict: string;
      itemCount: number;
    }>(`/tm/opportunities/${opportunityId}/go-checklist/recompute`);
    return data;
  },

  async overrideItem(itemId: number, input: OverrideChecklistItemInput): Promise<void> {
    await api.patch(`/tm/go-checklist-items/${itemId}/override`, input);
  },

  async clearOverride(itemId: number): Promise<void> {
    await api.delete(`/tm/go-checklist-items/${itemId}/override`);
  },
};
